var render = function render(_c,_vm){return _c('div',{staticClass:"has-bg-image",style:({
    width: '75px',
    height: '50px',
    borderRadius: '4px',
    backgroundImage: `url(${_vm.props.value})`,
    backgroundColor: 'whitesmoke'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }